import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useEffect, useMemo } from 'react';
import { useThrottleCallback } from '@react-hook/throttle';
import { TXLIST_PAGE_SIZE } from '@/utils/constants';
import Table from '@/components/base/Table';
import { getTransactionsColumns, getColumns, TXN_TYPE_REWARD } from '@/constants/Transaction';
import getTxService from '@/api/transactions';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
import { filterEmptyParams } from '@/utils';
import { useRouter } from 'next/router';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var PAGE_SIZE = TXLIST_PAGE_SIZE;
var txService = getTxService();
var TransactionTable = observer(function(props) {
    var ref5;
    var shard = props.shard, showType = props.showType, address = props.address, addresstxntype = props.addresstxntype, onTotalChange = props.onTotalChange, height = props.height, _showShard = props.showShard, showShard = _showShard === void 0 ? true : _showShard, _serverAPI = props.serverAPI, serverAPI = _serverAPI === void 0 ? 'getList' : _serverAPI, data = props.data, contract = props.contract;
    var router = useRouter();
    var ref1 = useState([]), transactions = ref1[0], setTransactions = ref1[1];
    var ref2 = useState(Number(router === null || router === void 0 ? void 0 : (ref5 = router.asPath) === null || ref5 === void 0 ? void 0 : ref5.split('#')[1]) || 1), pos = ref2[0], setpos = ref2[1];
    var ref3 = useState(0), total = ref3[0], setTotal = ref3[1];
    var ref4 = useState(false), tableLoading = ref4[0], setTableLoading = ref4[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getTransactions();
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        var ref;
        setpos(Number(router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split('#')[1]) || 1);
        getTransactions();
    }, [
        shard,
        contract,
        router
    ]);
    useEffect(function() {
        getTransactions();
    }, [
        pos
    ]);
    var getTransactions = useCallback(useThrottleCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var Result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!data) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", setTransactions(data));
                case 2:
                    setTableLoading(true);
                    _ctx.next = 5;
                    return txService[serverAPI](filterEmptyParams({
                        limit: PAGE_SIZE,
                        pos: (pos - 1) * PAGE_SIZE,
                        shardIndex: shard,
                        addresstxntype: addresstxntype,
                        address: address,
                        height: height,
                        contract: contract
                    }));
                case 5:
                    Result = _ctx.sent.Result;
                    if (Result) {
                        setTotal(Result.TotalNum);
                        onTotalChange && onTotalChange(Result.TotalNum);
                        setTransactions(Result.ListData);
                    } else {
                        setTotal(0);
                        onTotalChange && onTotalChange(0);
                        setTransactions([]);
                    }
                    setTableLoading(false);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))), [
        pos,
        shard,
        data
    ]);
    var uniqueKey = useCallback(function(row) {
        return (row === null || row === void 0 ? void 0 : row.TxnHash) ? row.TxnHash + '-' + row.Height : '-';
    }, []);
    var paginationOption = useMemo(function() {
        return {
            current: pos,
            pageSize: PAGE_SIZE,
            total: total,
            onPageChange: function(current) {
                setpos(current);
                router.push({
                    hash: current.toString()
                });
            }
        };
    }, [
        total,
        pos
    ]);
    return(/*#__PURE__*/ _jsx(Table, {
        columns: showShard ? getTransactionsColumns(showType, addresstxntype === TXN_TYPE_REWARD) : getColumns([], showType),
        data: data || transactions,
        rowKey: uniqueKey,
        pageOpt: paginationOption,
        loading: tableLoading,
        hideColumns: true
    }));
});
export default TransactionTable;
